module.exports = __webpack_public_path__ + "img/8.e3fb79b7.png";